import script from "./Financial.vue?vue&type=script&setup=true&lang=ts"
export * from "./Financial.vue?vue&type=script&setup=true&lang=ts"

import "./Financial.vue?vue&type=style&index=0&id=010fa5a7&lang=less&scoped=true"

import exportComponent from "D:\\work\\risfond-branchmanagementsystem\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-010fa5a7"]])

export default __exports__